import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import WifiDownIcon from "../../../assets/svgs/wifiDownIcon.svg";
import { StorageService } from "../../../utils/StorageUtils";

const OfflineComponent = () => {
  const getStoredImage = () => {
    const savedImage = StorageService.getItem("savedImage");
    return savedImage ? <img src={savedImage} alt="Network Offline" /> : null;
  };

  return (
    <Box
      bgColor={"#F5F4FA"}
      h={"100vh"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      margin={"auto"}
      padding={"auto"}
    >
      {/* <Image src={WifiDownIcon} alt="Network Offline" /> */}
      {getStoredImage()}
      <Text
        fontFamily={"Poppins"}
        fontWeight={"600"}
        fontSize={"24px"}
        lineHeight={"30px"}
        color={"#000000D9"}
        mb={"20px"}
      >
        Network Error
      </Text>
      <Text
        fontFamily={"Poppins"}
        fontWeight={"400"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#000000D9"}
      >
        The network connection is lost.
      </Text>
      <Text
        fontFamily={"Poppins"}
        fontWeight={"400"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#000000D9"}
      >
        Please check your connectivity and try again.
      </Text>
    </Box>
  );
};

export default OfflineComponent;
